const companys = (state = [], action) => {
    switch (action.type) {
      case 'COMPANYS':
          return action.companys.map(companys => {
            return companys
          })
      case 'DELCOMPANY':
          return state.filter(companys =>
            parseInt(companys.id) !== parseInt(action.companyid)
          )
      default:
        return state
    }
  }
  
  export default companys